import { Component } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { UserPermission } from 'src/app/enums/enums';
import { PermissionService } from 'src/app/services/app/permission-access-service/permissionBased.service';
import { CancelReasonsService } from 'src/app/services/core/cancelReason/cancel-reasons.service';
import { NUMBER_OF_RECORDS } from 'src/app/utils/common.utils';
@UntilDestroy()

@Component({
  selector: 'app-list-cancel-reason',
  templateUrl: './list-cancel-reason.component.html',
  styleUrls: ['./list-cancel-reason.component.css']
})
export class ListCancelReasonComponent {
    selectedStatus: any = '';
    cancelReasonData: any = [];
    cancelReasonId: any;
    filterCancelReasonList: any;
    totalPages = 0;
    totalResults = 0;
    currentPage:number = 1
    numberOfRecords = NUMBER_OF_RECORDS;
    search:any
    status = true;
    userPermission=UserPermission;
    changeReasonModalObj:any;
    constructor(private cancelReasonsService: CancelReasonsService,public permissionService: PermissionService){
  
    }
  
    ngOnInit(){
      this.getCancelReason(this.currentPage);
    }
  
    getCancelReason(page: number) {
      const queryparams = {
        limit: 50,
        page,
        isActive: this.status
      };
      this.cancelReasonsService.get(queryparams).pipe(untilDestroyed(this)).subscribe((data: any) => {
        if (data.results ) {
          this.cancelReasonData = data.results;
          this.cancelReasonData = data.results.sort((a: any, b: any) =>
            new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
          );
          this.filterCancelReasonList = this.cancelReasonData;
          this.totalPages = data.totalPages;
          this.totalResults = data.totalResults;
        }
      });
    }
    
  
    onPageChange(page: number) {
      this.currentPage = page;
      this.getCancelReason(page);
    }
  
    onSelectStatus(event: any): void {
     this.status = event.target.value === 'true';
    this.getCancelReason(this.currentPage = 1);
    }

  openChangeReasonModal(changeReason: any) {
    this.changeReasonModalObj = changeReason;
  }

  onSaveChangeReason(evt: any) {
    if (evt) {
      const idx = this.filterCancelReasonList.findIndex((fs: any) => fs.id === evt.id);
      if (this.status === evt.isActive) {
        this.filterCancelReasonList[idx] = evt;
      } else {
        this.filterCancelReasonList.splice(idx, 1);
      }
    }
    this.changeReasonModalObj = null;
  }

  onCloseChangeReasonModal() {
    this.changeReasonModalObj = null;
  }
  
}
